import { render, staticRenderFns } from "./guests-info.vue?vue&type=template&id=7954c115"
import script from "./guests-info.vue?vue&type=script&lang=js"
export * from "./guests-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports